import { useEffect, useState, useContext } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Modal from 'react-modal';

import useToken from "../../hooks/useToken";
import { DataContext, DataProvier } from "./data/DataContext";
import { InitPage, TotalPage } from './data/Data';
import http from '../../services/http';
import { endPoints, tipoNotificacionEnum } from '../../utils/constanst';
import { GetDataRates, propMsg, BuilData, BuildDataOportunity, GetVehicleValueDepre, GetDataNotification } from './data/Help';

import { LineProgressBar, ControlButton, ModalMsgControl } from './components/controls';
import { Pages, PagesTitle } from './components/pages'
import { ImgUser } from './img';

import './Auto.css';


const Auto = () => {
    const { loading } = useToken();

    useEffect(() => {
        setTimeout(() => {
            const preloader: any = document.querySelector(".site-preloader");
            if (preloader) {
                preloader.addEventListener("transitionend", (event: any) => {
                    if (event.propertyName === "opacity") {
                        preloader.parentNode.removeChild(preloader);
                    }
                });
                preloader.classList.add("site-preloader__fade");
            }
        }, 600);
    }, []);

    return (
        <DataProvier loading={loading} >
            <BrowserRouter basename={process.env.PUBLIC_URL}>
                <Switch>
                    <Route exact path="/micrositio/auto_ni/" component={Layout} />
                </Switch>
            </BrowserRouter>
        </DataProvier>
    );
}

const Layout = ({ location }: IPropsParam) => {

    const [index, setIndex] = useState(InitPage);
    const { AutoNI, setAutoNI } = useContext(DataContext);
    const [propModalMsg, setPropModalMsg] = useState(propMsg);
    const [propModalMsgError, setPropModalMsgError] = useState(propMsg);
    const [isValidVin, setIsValidVin] = useState(true);



    const Decrement = () => (index !== 0) ? setIndex(index - 1) : 0;
    const Increment = () => (index <= TotalPage) ? setIndex(index + 1) : 0;
    const GetTextBtn = () => index === 2 ? "Generar oferta" : "Siguiente";



    useEffect(() => {
        if ((AutoNI.vehicleBrand !== '' && AutoNI.vehicleBrand !== undefined) && (AutoNI.vehicleModel !== '' && AutoNI.vehicleModel !== undefined) && (AutoNI.vehicleYear !== '' && AutoNI.vehicleYear !== undefined)) {
            setPropModalMsg({ ...propModalMsg, active: true });
            http(endPoints.datasheet(AutoNI.idPlan, AutoNI.vehicleBrand, AutoNI.vehicleModel, AutoNI.vehicleYear)).get()
                .then(result => {
                    setAutoNI({ ...AutoNI, datasheet: result, vehicleValue: result.auValorNuevo, vehicleValueStr: result.auValorNuevo, isDatasheet: true });
                }).catch((error) => {
                    setPropModalMsgError({ ...propModalMsgError, active: true, isloading: false, txtMsg: error });
                }).finally(() => {
                    setPropModalMsg({ ...propModalMsg, active: false });
                })
        }
    }, [AutoNI.vehicleYear]);

    useEffect(() => {
        if (AutoNI.vehicleValue !== '' && AutoNI.vehicleStatus !== '') {
            let mount: string = '';
            if (AutoNI.vehicleStatus === '1')
                mount = AutoNI.vehicleValue;
            else if (AutoNI.vehicleStatus === '0')
                mount = GetVehicleValueDepre(AutoNI);

            setAutoNI({ ...AutoNI, sumAssured: mount })
        }
    }, [AutoNI.vehicleValue]);

    useEffect(() => {
        if (AutoNI.vehicleStatus !== '') {
            if (AutoNI.vehicleStatus === '0') {
                let mount: string = '';
                mount = GetVehicleValueDepre(AutoNI);

                setAutoNI({ ...AutoNI, vehicleValue: AutoNI.vehicleValueStr, sumAssured: mount });
            }
            else {
                setAutoNI({ ...AutoNI, vehicleValue: AutoNI.vehicleValueStr, sumAssured: AutoNI.vehicleValueStr });

            }

        }
    }, [AutoNI.vehicleStatus]);

    useEffect(() => {
        if (!isValidVin)
            SendNotification();
    }, [isValidVin])

    const InitPlan = () => {
        setPropModalMsg({ ...propModalMsg, active: true });
        Promise.all([
            http(endPoints.configPlan(1, AutoNI.idPlan)).get(),
            http(endPoints.vhUses).get(),
            http(endPoints.brands(AutoNI.idPlan)).get(),
            http(endPoints.fees(AutoNI.idPlan)).getWithParam(`plan=${AutoNI.idPlan}`),
            http(endPoints.coverages(AutoNI.idPlan)).get(),
        ]).then(result => {

            const ids = result[1].map((value: any) => value.value);
            const filtered = result[1].filter((item: any, index: any) => !ids.includes(item.value, index + 1));

            setAutoNI({
                ...AutoNI,
                planConfig: result[0],
                catVehicleUse: filtered,
                catVehicleBrand: result[2],
                catPaymentFrequency: result[3],
                coveragesPlan: result[4],
            });
            Increment();
        }).finally(() => {
            setPropModalMsg({ ...propModalMsg, active: false });
        })
    }

    const GetRates = () => {
        let data = GetDataRates(AutoNI);
        setPropModalMsg({ ...propModalMsg, active: true, txtMsg: 'Tarificando...' });
        http(endPoints.tarificar(AutoNI.idPlan)).post(data)
            .then((result) => {
                setAutoNI({ ...AutoNI, rates: result });
                Increment();
            })
            .catch((error) => (setPropModalMsgError({ ...propModalMsg, active: true, txtMsg: error, isloading: false })))
            .finally(() => (setPropModalMsg({ ...propModalMsg, active: false })));

    }

    const CreatePolicy = () => {
        setPropModalMsg({ ...propModalMsg, active: true, txtMsg: 'Creando oferta...' });
        let searchParams = new URLSearchParams(location.search);
        let src = searchParams.get('source') === undefined ? '' : searchParams.get('source');
        const data = BuilData(AutoNI, src);

        http(endPoints.createCotizadorNi).post(data)
            .then((result) => {

                setAutoNI({ ...AutoNI, saved: true, policyNumber: result.id });
                setPropModalMsg({ ...propModalMsg, active: false });
                http(endPoints.welcomeNotificationAutoNI(result.id, AutoNI.mail))
                    .get().catch(x => console.log(x));
                downloadReport(result.id);
            }).catch((error) => {
                setPropModalMsg({ ...propModalMsg, active: false });
            }).finally(() => {

                Increment();
            });
    }

    const Submit = () => {
        let result = document.querySelector("form") as HTMLFormElement;
        switch (index) {
            case 0:
                if (result.reportValidity())
                    SendOportunity();
                break;
            case 1:
                if (result.reportValidity())
                    ValidateVin();
                break;
            case 2:
                CreatePolicy();
                break;
            default:
                if (result.reportValidity())
                    Increment();
                break;
        }
    }

    const ValidateVin = () => {
        let data = {
            "vin": AutoNI.vehicleChassis
        }
        setPropModalMsg({ ...propModalMsg, active: true, txtMsg: 'Validando datos...' });
        http(endPoints.validateVin).post(data)
            .then((res: boolean) => {
                setPropModalMsg({ ...propModalMsg, active: false, txtMsg: 'Validando datos...' });
                if (res)
                    GetRates();
                else
                    setIsValidVin(false);
            }).catch(() => {
                setPropModalMsg({ ...propModalMsg, active: false, txtMsg: 'Validando datos...' });
                setIsValidVin(false);
            });
    }

    const SendOportunity = () => {
        let searchParams = new URLSearchParams(location.search);
        let src = searchParams.get('source');

        const data = BuildDataOportunity(AutoNI, src ?? '');
        setPropModalMsg({ ...propModalMsg, active: true });
        http(endPoints.createOportunityAuto)
            .post(data)
            .then(x => { setPropModalMsg({ ...propModalMsg, active: false }); })
            //  .then(x => setAutoNI({ ...AutoNI, opportunitySent: true }))
            .catch((error) => {
                setPropModalMsg({ ...propModalMsg, active: false });
            })
            .finally(() => InitPlan())
    }

    const downloadReport = (id: number) => {
        if (id !== 0) {
            setPropModalMsg({ ...propModalMsg, active: true, txtMsg: 'Descargando oferta' });
            http(endPoints.descargarOferta(id)).get().finally(() => (setPropModalMsg({ ...propModalMsg, active: false })));
        }
    }

    const SendNotification = () => {
        let data = GetDataNotification(AutoNI, tipoNotificacionEnum.SiniestroSalvamento);
        http(endPoints.sendNotificationAuto).multipleFileData(data, data.adjuntos);
    }



    return (
        <div className="container">
            <div className="layout-autoni">
                <div className="mt-10">
                    <p className="lbl-encabezado1-autoni mb-10">
                        {index !== 3 && '¡Calcula tu seguro ahora!'}
                        {index === 3 && '¡Cotización exitosa!'}
                    </p>
                    <p className="lbl-encabezado2-autoni mt-0 mb-30">
                        {index !== 3 && ' Con tu póliza de Auto Seguro Plus disfruta cada momento sin preocupaciones'}
                        {index === 3 && 'Muchas gracias por confiar en Seguros LAFISE, Soluciones sin fronteras'}
                    </p>
                </div>
                <LineProgressBar index={(index < TotalPage ? index + 1 : TotalPage)} totalPages={TotalPage} />
                <form>
                    <div className="step-autoni">
                        <div className="step-container-ihcr">
                            <PagesTitle index={index} />
                            <Pages index={index} />
                        </div>
                    </div>
                    <ControlButton indexPage={index}>
                        {index !== 0 &&
                            <button
                                className={`control-button-btn-autoni prev`}
                                type="button"
                                onClick={Decrement}
                            >
                                Regresar
                            </button>
                        }
                        {
                            <button
                                className="control-button-btn-autoni next"
                                type="button"
                                onClick={Submit}
                            >
                                {GetTextBtn()}
                            </button>
                        }
                    </ControlButton>
                </form>
            </div>
            <ModalMsgControl
                active={propModalMsg.active}
                txtMsg={propModalMsg.txtMsg}
                isloading={propModalMsg.isloading}
                closeModal={() => setPropModalMsg({ ...propModalMsg, active: false })}
            />
            <ModalMsgControl
                active={propModalMsgError.active}
                txtMsg={propModalMsgError.txtMsg}
                isloading={propModalMsgError.isloading}
                closeModal={() => setPropModalMsgError({ ...propModalMsgError, active: false })}
            />
            <Modal className='modal' isOpen={!isValidVin} ariaHideApp={false}>
                <div style={{ display: "flex", justifyContent: 'center' }}>
                    <ImgUser />
                </div>
                <div className="modal-body-info" style={{ textAlign: "center", color: '#FF0000' }}>
                    Ha ocurrido un error
                </div>
                <div className="modal-body-info" style={{ textAlign: "center", color: '#4D4D4D' }}>
                    Un ejecutivo de Seguros LAFISE se
                    comunicará con usted lo antes posible
                </div>

            </Modal>
        </div>
    );
}

export default Auto;